<dl class="space-y-6 divide-y divide-gray-200 p-3">
  <app-error-item *ngFor="let error of errors" [error]="error"></app-error-item>
</dl>
